import { type ColumnOptions } from "../../../../interfaces";

const columnOptions: ColumnOptions[] = [
  {
    name: "Name",
    width: 4,
    isSortable: true,
  },
  {
    name: "Department",
    width: 3,
    isSortable: true,
  },
  {
    name: "Job title",
    width: 3,
    isSortable: true,
  },
  {
    name: "Roles",
    width: 4,
    isSortable: false,
  },
  {
    name: "",
    width: 1,
    isSortable: false,
  },
];

export default columnOptions;
